import axios from "axios";
import { invoiceApi, tmsApi } from "../api";

export const getZoneList = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(invoiceApi + `api/zone/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getZoneDetailsById = (id) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(invoiceApi + `api/zone/detail/${id}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const createZone = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(invoiceApi + `api/zone/create`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const updateZone = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .put(invoiceApi + `api/zone/update`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const deleteZone = (id) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .delete(invoiceApi + `api/zone/delete/${id}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getAllZoneCapture =(obj)=>{
    console.log("getAllZoneCapture",obj)
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/bookings/zonecapture?page=${obj.page}&size=${obj.size}`,
                {
                    fromDate:obj.fromDate,
                    toDate:obj.toDate
                }
                ,config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
}
export const getAllZoneCaptureBySearch =(obj)=>{
    console.log("getAllZoneCapture",obj)
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios 
            .post(tmsApi + `v1/entities/bookings/search/${obj.name}?page=${obj.page}&size=${obj.size}`,
                {
                    fromDate:obj.fromDate,
                    toDate:obj.toDate
                }
                ,config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
}
